import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { Link as RouterLink } from "react-router-dom";
import { useRouteMatch } from "react-router-dom";
import * as actions from "../../redux/actions/index";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Button from "@material-ui/core/Button";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Link from "@material-ui/core/Link";
import Toolbar from "@material-ui/core/Toolbar";
import getTheme from "../../theme/index";
import HideTextForSmall from "../Shared/HideTextForSmall";

const useStyles = makeStyles((theme) =>
    createStyles({
        allListingsButtonWrapper: {
            padding: theme.spacing(1),
            textAlign: "right",
        },
        header: {
            height: "60px",
            [theme.breakpoints.up("sm")]: {
                height: "80px",
            },
            [theme.breakpoints.up("md")]: {
                height: "100px",
            },
        },
        linkButton: {
            color: theme.palette.primary.contrastText,
        },
        menuIcon: {
            fill: theme.palette.primary.main,
        },
        logo: {
            height: "60%",
            width: "auto",
        },
        logoWrapper: {
            display: "flex",
            height: "100%",
            flexGrow: 1,
            alignItems: "center",
        },
        logoutButtonWrapper: {
            padding: theme.spacing(2),
        },
        toolbar: {
            height: "100%",
        },
    })
);

export default function MenuBar(props) {
    const classes = useStyles();
    const showSpecificListing = useRouteMatch("/listing/:id") ? true : false; // Make sure that this is always a boolean response for the CSSTransition in prop.
    const user = useSelector((state) => state.user);
    const logo = getTheme(user?.userData?.theme).logo
    const dispatch = useDispatch();

    const handleClick = () => {
        if (user.isLoggedIn) {
            dispatch(actions.userLogout());
        }
    };

    return (
        <AppBar className={classes.header} position="fixed" color="secondary">
            <Toolbar className={classes.toolbar}>
                <div className={classes.logoWrapper}>
                    <img
                        className={classes.logo}
                        src={logo}
                        alt="Nelson Alexander"
                        width="185"
                        height="66"
                    />
                </div>
                {user.isLoggedIn ? (
                    <CSSTransition
                        in={showSpecificListing}
                        timeout={1000}
                        classNames="fade-animation"
                        unmountOnExit
                        appear
                        key="allListings"
                    >
                        <div className={classes.allListingsButtonWrapper}>
                            <Button
                                className={classes.headingButton}
                                variant="contained"
                                color="primary"
                                endIcon={<ArrowBackIcon />}
                                component={RouterLink}
                                to="/"
                            >
                                <HideTextForSmall>
                                    All Listings
                                </HideTextForSmall>
                            </Button>
                        </div>
                    </CSSTransition>
                ) : (
                    ""
                )}
                <div className={classes.logoutButtonWrapper}>
                    <Button
                        className={classes.linkButton}
                        component={Link}
                        variant="contained"
                        color="primary"
                        endIcon={<ExitToAppIcon />}
                        href={user.isLoggedIn ? "" : "/login/"}
                        onClick={handleClick}
                    >
                        <HideTextForSmall>
                            {user.isLoggedIn ? "LOGOUT" : "LOGIN"}
                        </HideTextForSmall>
                    </Button>
                </div>
                {/* <ChangePassModal handle={handleModal} open={true}/> */}
            </Toolbar>
        </AppBar>
    );
}
